import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wr lot-block-wrapper" }
const _hoisted_2 = { class: "dashboard-header" }
const _hoisted_3 = { class: "breadcrumb-wrapper-main" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = { class: "current-breadcrumb" }
const _hoisted_6 = { class: "title-controls" }
const _hoisted_7 = { class: "wrapper-switch" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'AdminUser', params: { userId: $setup.userId } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.getFirstLastName($setup.user)), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "delimiter" }, null, -1)),
          _createVNode(_component_router_link, {
            to: { name: 'AdminEstate', params: { userId: $setup.userId, estateId: $setup.estateId } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.estate ? $setup.estate.title : ""), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "delimiter" }, null, -1)),
          _createVNode(_component_router_link, {
            to: { name: 'AdminStage', params: { userId: $setup.userId, estateId: $setup.estateId, stageId: $setup.stageId } }
          }, {
            default: _withCtx(() => [
              _createTextVNode("Stage " + _toDisplayString($setup.stage ? $setup.stage.title : ""), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "delimiter" }, null, -1)),
          _createElementVNode("div", _hoisted_5, "Lot " + _toDisplayString($setup.lot ? $setup.lot.title : ""), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["badge big", $setup.getLotStatusClass($setup.lot ? ($setup.lot.status === $setup.LotStatus.EOI ? $setup.LotStatus.PRE_CONTRACT : $setup.lot.status) : '')])
          }, _toDisplayString($setup.getLotStatus), 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        ($setup.canEditLot($setup.lot?.status))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "button default edit",
              to: { name: 'AdminLotUpdate', params: { userId: $setup.userId, estateId: $setup.estateId, stageId: $setup.stageId, lotId: $setup.lotId } }
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Edit", -1)
              ]))]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode($setup["LotLifecycle"], { lot: $setup.lot }, null, 8, ["lot"]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode($setup["SwitchComponent"], {
        modelValue: $setup.currentTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.currentTab) = $event)),
        list: $setup.tabs,
        slots: ['customSwitch']
      }, {
        customSwitch: _withCtx((item) => [
          _createElementVNode("span", {
            class: "switch-item--text",
            onClick: ($event: any) => ($setup.toTab(item.label))
          }, _toDisplayString(item.label), 9, _hoisted_8)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_router_view, {
      lot: $setup.lot,
      estate: $setup.estate,
      isAdmin: true,
      role: $setup.UserRoles.SUPER_ADMIN,
      class: _normalizeClass({ 'map-wr': $setup.currentTab.label === 'map' }),
      onUpdateLot: $setup.getLot,
      onAddDocument: _cache[1] || (_cache[1] = ($event: any) => ($setup.addDocument($event))),
      onDeleteDocument: _cache[2] || (_cache[2] = ($event: any) => ($setup.deleteDocument($event)))
    }, null, 8, ["lot", "estate", "role", "class"])
  ]))
}